import { EntitiesStore } from './entities-store.abstract';

import { HttpClient } from '@angular/common/http';

import { Injector } from '@angular/core';

import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { filter, map, tap, combineLatest, mergeMap } from 'rxjs/operators';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import * as rx from 'rxjs'
import { ActivatedRoute, Router } from '@angular/router';

export interface Athlete {
  GName: string;
  FName: string;
  WNameOrd: string;
  id: number;
}

export interface Competition {
  name: string;
  id: number;
  place: string;
  country: string;
  date_start: string;
  date_end: string;
}

export interface Image {
  smugmug_id: string;
  alt?:string;
  path: string;
  athletes: Athlete[];
  competition: Competition;
}

export interface ITabPhotoContent {
  id: string;
  images: Image[];
  title: string;
}


export type Tabs = {
  [key in string | number]: ITabPhotoContent;
};

export interface Datum {
  id: number;
  tabs: Tabs;
}

export interface IGalleryPhotos {
  data: Datum[];
}


const mockData = {
  "data": [
    {
      "id": 23126,
      "tabs": {
        "612": {
          "id": "612",
          "title": "PRACTICE",
          "images": [
            {
              "smugmug_id": "DD8NHgG",
              "path": "DD8NHgG",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "B9dtrVW",
              "path": "B9dtrVW",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "PvddPFX",
              "path": "PvddPFX",
              "athletes": [
                {
                  "GName": "Chabin",
                  "FName": "Keziah",
                  "WNameOrd": "",
                  "id": 18922
                },
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                },
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                },
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                },
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                },
                {
                  "GName": "Damsbo",
                  "FName": "Erika",
                  "WNameOrd": "",
                  "id": 3392
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "PQxqS2z",
              "path": "PQxqS2z",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "zkk9bqz",
              "path": "zkk9bqz",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "rZLr7rC",
              "path": "rZLr7rC",
              "athletes": [
                {
                  "GName": "Hofer",
                  "FName": "Patrizio",
                  "WNameOrd": "",
                  "id": 1365
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "XV4WKGv",
              "path": "XV4WKGv",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "r7TSpJ7",
              "path": "r7TSpJ7",
              "athletes": [
                {
                  "GName": "Studer",
                  "FName": "Anne-Marie",
                  "WNameOrd": "",
                  "id": 35714
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "J53W8d8",
              "path": "J53W8d8",
              "athletes": [
                {
                  "GName": "Studer",
                  "FName": "Anne-Marie",
                  "WNameOrd": "",
                  "id": 35714
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "mRF4wrs",
              "path": "mRF4wrs",
              "athletes": [
                {
                  "GName": "Barankova",
                  "FName": "Denisa",
                  "WNameOrd": "",
                  "id": 20532
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "VF7hJP5",
              "path": "VF7hJP5",
              "athletes": [
                {
                  "GName": "Chabin",
                  "FName": "Keziah",
                  "WNameOrd": "",
                  "id": 18922
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "LMVg94R",
              "path": "LMVg94R",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "HB7GJjW",
              "path": "HB7GJjW",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "kr4LzW6",
              "path": "kr4LzW6",
              "athletes": [
                {
                  "GName": "Girard",
                  "FName": "Nicolas",
                  "WNameOrd": "",
                  "id": 19461
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "f8rT9nW",
              "path": "f8rT9nW",
              "athletes": [
                {
                  "GName": "Girard",
                  "FName": "Nicolas",
                  "WNameOrd": "",
                  "id": 19461
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "3RM6PPX",
              "path": "3RM6PPX",
              "athletes": [
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                },
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "MQzF37C",
              "path": "MQzF37C",
              "athletes": [
                {
                  "GName": "Tombul",
                  "FName": "Alexis",
                  "WNameOrd": "1",
                  "id": 18771
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "D5jMx3G",
              "path": "D5jMx3G",
              "athletes": [
                {
                  "GName": "Tombul",
                  "FName": "Alexis",
                  "WNameOrd": "1",
                  "id": 18771
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "WWfpnmL",
              "path": "WWfpnmL",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "kJdt4vq",
              "path": "kJdt4vq",
              "athletes": [
                {
                  "GName": "Tombul",
                  "FName": "Alexis",
                  "WNameOrd": "1",
                  "id": 18771
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "PkzHf52",
              "path": "PkzHf52",
              "athletes": [
                {
                  "GName": "Bosansky",
                  "FName": "Jozef",
                  "WNameOrd": "",
                  "id": 19779
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "jTK22vL",
              "path": "jTK22vL",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                },
                {
                  "GName": "Damsbo",
                  "FName": "Erika",
                  "WNameOrd": "",
                  "id": 3392
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "XM3wCTv",
              "path": "XM3wCTv",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "Hsfhtvd",
              "path": "Hsfhtvd",
              "athletes": [
                {
                  "GName": "Chirault",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 15723
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "j2mDxCR",
              "path": "j2mDxCR",
              "athletes": [
                {
                  "GName": "Gaubil",
                  "FName": "Melanie",
                  "WNameOrd": "",
                  "id": 12394
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "4ZgzzGd",
              "path": "4ZgzzGd",
              "athletes": [
                {
                  "GName": "Chirault",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 15723
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "b2BN7PF",
              "path": "b2BN7PF",
              "athletes": [
                {
                  "GName": "Barbelin",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 3283
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "hSZ8723",
              "path": "hSZ8723",
              "athletes": [
                {
                  "GName": "Bauer",
                  "FName": "Katharina",
                  "WNameOrd": "",
                  "id": 9036
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "3SXQswV",
              "path": "3SXQswV",
              "athletes": [
                {
                  "GName": "Vetter",
                  "FName": "Jonathan",
                  "WNameOrd": "",
                  "id": 20657
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "jwXRMVL",
              "path": "jwXRMVL",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                },
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "QCKTgJs",
              "path": "QCKTgJs",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                },
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "F2mvhmZ",
              "path": "F2mvhmZ",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                },
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "vRxvhzk",
              "path": "vRxvhzk",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "vwp5Gc9",
              "path": "vwp5Gc9",
              "athletes": [
                {
                  "GName": "Wieser",
                  "FName": "Felix",
                  "WNameOrd": "",
                  "id": 13105
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "KvrGvTt",
              "path": "KvrGvTt",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "JGRbtVB",
              "path": "JGRbtVB",
              "athletes": [
                {
                  "GName": "Wieser",
                  "FName": "Felix",
                  "WNameOrd": "",
                  "id": 13105
                },
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                },
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "zg4VXwK",
              "path": "zg4VXwK",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "SDSCVJC",
              "path": "SDSCVJC",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "Z72ThnH",
              "path": "Z72ThnH",
              "athletes": [
                {
                  "GName": "Gonzalez",
                  "FName": "Gina",
                  "WNameOrd": "",
                  "id": 4784
                },
                {
                  "GName": "Aubert",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 5974
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "CdmMtsG",
              "path": "CdmMtsG",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Erika",
                  "WNameOrd": "",
                  "id": 3392
                },
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "svCWDGz",
              "path": "svCWDGz",
              "athletes": [
                {
                  "GName": "Ackx",
                  "FName": "Enzo",
                  "WNameOrd": "",
                  "id": 8918
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "7gFc7Sb",
              "path": "7gFc7Sb",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                },
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                },
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                },
                {
                  "GName": "Damsbo",
                  "FName": "Erika",
                  "WNameOrd": "",
                  "id": 3392
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "hHfB8T4",
              "path": "hHfB8T4",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                },
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "CP34Xcg",
              "path": "CP34Xcg",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "tvzXLvP",
              "path": "tvzXLvP",
              "athletes": [
                {
                  "GName": "Vetter",
                  "FName": "Jonathan",
                  "WNameOrd": "",
                  "id": 20657
                },
                {
                  "GName": "Bauer",
                  "FName": "Katharina",
                  "WNameOrd": "",
                  "id": 9036
                },
                {
                  "GName": "Wieser",
                  "FName": "Felix",
                  "WNameOrd": "",
                  "id": 13105
                },
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                },
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "TVbQDSP",
              "path": "TVbQDSP",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            }
          ]
        },
        "613": {
          "id": "613",
          "title": "QUALIFICATION",
          "images": [
            {
              "smugmug_id": "fCqVXJK",
              "path": "fCqVXJK",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Erika",
                  "WNameOrd": "",
                  "id": 3392
                },
                {
                  "GName": "De Giuli",
                  "FName": "Clementine",
                  "WNameOrd": "",
                  "id": 8879
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "f6Cwkcf",
              "path": "f6Cwkcf",
              "athletes": [
                {
                  "GName": "Dielen",
                  "FName": "Tom",
                  "WNameOrd": "",
                  "id": 8999
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "DM2tsSJ",
              "path": "DM2tsSJ",
              "athletes": [
                {
                  "GName": "Haefelfinger",
                  "FName": "Roman",
                  "WNameOrd": "",
                  "id": 15063
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "qcZSV7n",
              "path": "qcZSV7n",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "h9j2rsD",
              "path": "h9j2rsD",
              "athletes": [
                {
                  "GName": "Girard",
                  "FName": "Nicolas",
                  "WNameOrd": "",
                  "id": 19461
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "G9fzDGP",
              "path": "G9fzDGP",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "Tvf7mbf",
              "path": "Tvf7mbf",
              "athletes": [
                {
                  "GName": "Paas",
                  "FName": "Meeri-Marita",
                  "WNameOrd": "",
                  "id": 17640
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "FhJZW2p",
              "path": "FhJZW2p",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "2cMwMMQ",
              "path": "2cMwMMQ",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "rkGzNhG",
              "path": "rkGzNhG",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "zj9HPv4",
              "path": "zj9HPv4",
              "athletes": [
                {
                  "GName": "Ackx",
                  "FName": "Enzo",
                  "WNameOrd": "",
                  "id": 8918
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "dVqPMHG",
              "path": "dVqPMHG",
              "athletes": [
                {
                  "GName": "Bosansky",
                  "FName": "Jozef",
                  "WNameOrd": "",
                  "id": 19779
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "qgsjFwx",
              "path": "qgsjFwx",
              "athletes": [
                {
                  "GName": "Girard",
                  "FName": "Nicolas",
                  "WNameOrd": "",
                  "id": 19461
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "GBk9vfq",
              "path": "GBk9vfq",
              "athletes": [
                {
                  "GName": "Ackx",
                  "FName": "Enzo",
                  "WNameOrd": "",
                  "id": 8918
                },
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "PHk74Qr",
              "path": "PHk74Qr",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "rdGX2xr",
              "path": "rdGX2xr",
              "athletes": [
                {
                  "GName": "De Giuli",
                  "FName": "Clementine",
                  "WNameOrd": "",
                  "id": 8879
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "rGnWPbF",
              "path": "rGnWPbF",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Erika",
                  "WNameOrd": "",
                  "id": 3392
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "fGSLJRD",
              "path": "fGSLJRD",
              "athletes": [
                {
                  "GName": "Zikmundova",
                  "FName": "Martina",
                  "WNameOrd": "",
                  "id": 19781
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "9mKPn84",
              "path": "9mKPn84",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "CwpNcqd",
              "path": "CwpNcqd",
              "athletes": [
                {
                  "GName": "Zikmundova",
                  "FName": "Martina",
                  "WNameOrd": "",
                  "id": 19781
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "NLdLNgg",
              "path": "NLdLNgg",
              "athletes": [
                {
                  "GName": "Paas",
                  "FName": "Meeri-Marita",
                  "WNameOrd": "",
                  "id": 17640
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "3R9JPv6",
              "path": "3R9JPv6",
              "athletes": [
                {
                  "GName": "Grandjean",
                  "FName": "Lola",
                  "WNameOrd": "",
                  "id": 19459
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "p5TnqCF",
              "path": "p5TnqCF",
              "athletes": [
                {
                  "GName": "Studer",
                  "FName": "Anne-Marie",
                  "WNameOrd": "",
                  "id": 35714
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "K9WT7MG",
              "path": "K9WT7MG",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "J4RhQz5",
              "path": "J4RhQz5",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "cC37ts9",
              "path": "cC37ts9",
              "athletes": [
                {
                  "GName": "Bosansky",
                  "FName": "Jozef",
                  "WNameOrd": "",
                  "id": 19779
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "n69Q25n",
              "path": "n69Q25n",
              "athletes": [
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "hQF3Fc2",
              "path": "hQF3Fc2",
              "athletes": [
                {
                  "GName": "Rufer",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 13033
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "8fWwHGm",
              "path": "8fWwHGm",
              "athletes": [
                {
                  "GName": "Faber",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12511
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "zss87tK",
              "path": "zss87tK",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "kF4QVmk",
              "path": "kF4QVmk",
              "athletes": [
                {
                  "GName": "Vetter",
                  "FName": "Jonathan",
                  "WNameOrd": "",
                  "id": 20657
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "XHCcrxm",
              "path": "XHCcrxm",
              "athletes": [
                {
                  "GName": "Wieser",
                  "FName": "Felix",
                  "WNameOrd": "",
                  "id": 13105
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "BQZ9GmD",
              "path": "BQZ9GmD",
              "athletes": [
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "9hcB36r",
              "path": "9hcB36r",
              "athletes": [
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "nCnmFwC",
              "path": "nCnmFwC",
              "athletes": [
                {
                  "GName": "Chirault",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 15723
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "8GnsSDH",
              "path": "8GnsSDH",
              "athletes": [
                {
                  "GName": "Bauer",
                  "FName": "Katharina",
                  "WNameOrd": "",
                  "id": 9036
                },
                {
                  "GName": "Licari",
                  "FName": "Liliana",
                  "WNameOrd": "",
                  "id": 36533
                },
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "hzTxHSm",
              "path": "hzTxHSm",
              "athletes": [
                {
                  "GName": "Gerster",
                  "FName": "Simone",
                  "WNameOrd": "",
                  "id": 36532
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "Mw6t7rj",
              "path": "Mw6t7rj",
              "athletes": [
                {
                  "GName": "Licari",
                  "FName": "Liliana",
                  "WNameOrd": "",
                  "id": 36533
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "TtrbhtQ",
              "path": "TtrbhtQ",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "SRFWcQ9",
              "path": "SRFWcQ9",
              "athletes": [
                {
                  "GName": "Gerster",
                  "FName": "Simone",
                  "WNameOrd": "",
                  "id": 36532
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "5hXpQbt",
              "path": "5hXpQbt",
              "athletes": [
                {
                  "GName": "Bauer",
                  "FName": "Katharina",
                  "WNameOrd": "",
                  "id": 9036
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "sX6SfxJ",
              "path": "sX6SfxJ",
              "athletes": [
                {
                  "GName": "Barbelin",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 3283
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "tht4xB8",
              "path": "tht4xB8",
              "athletes": [
                {
                  "GName": "Barankova",
                  "FName": "Denisa",
                  "WNameOrd": "",
                  "id": 20532
                },
                {
                  "GName": "Barbelin",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 3283
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "w8fdj23",
              "path": "w8fdj23",
              "athletes": [
                {
                  "GName": "Barankova",
                  "FName": "Denisa",
                  "WNameOrd": "",
                  "id": 20532
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "HCLcfgr",
              "path": "HCLcfgr",
              "athletes": [
                {
                  "GName": "Gaubil",
                  "FName": "Melanie",
                  "WNameOrd": "",
                  "id": 12394
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "Lnq96bp",
              "path": "Lnq96bp",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "k5sxNMs",
              "path": "k5sxNMs",
              "athletes": [
                {
                  "GName": "Licari",
                  "FName": "Liliana",
                  "WNameOrd": "",
                  "id": 36533
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "vPqKxq9",
              "path": "vPqKxq9",
              "athletes": [
                {
                  "GName": "Barankova",
                  "FName": "Denisa",
                  "WNameOrd": "",
                  "id": 20532
                },
                {
                  "GName": "Barbelin",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 3283
                },
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "rwnM9DK",
              "path": "rwnM9DK",
              "athletes": [
                {
                  "GName": "Gerster",
                  "FName": "Simone",
                  "WNameOrd": "",
                  "id": 36532
                },
                {
                  "GName": "Bauer",
                  "FName": "Katharina",
                  "WNameOrd": "",
                  "id": 9036
                },
                {
                  "GName": "Licari",
                  "FName": "Liliana",
                  "WNameOrd": "",
                  "id": 36533
                },
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "CCsP5DQ",
              "path": "CCsP5DQ",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Erika",
                  "WNameOrd": "",
                  "id": 3392
                },
                {
                  "GName": "De Giuli",
                  "FName": "Clementine",
                  "WNameOrd": "",
                  "id": 8879
                },
                {
                  "GName": "Zikmundova",
                  "FName": "Martina",
                  "WNameOrd": "",
                  "id": 19781
                },
                {
                  "GName": "Paas",
                  "FName": "Meeri-Marita",
                  "WNameOrd": "",
                  "id": 17640
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "jtF3tFb",
              "path": "jtF3tFb",
              "athletes": [
                {
                  "GName": "Fraigneau",
                  "FName": "Clémence",
                  "WNameOrd": "",
                  "id": 22563
                },
                {
                  "GName": "Studer",
                  "FName": "Anne-Marie",
                  "WNameOrd": "",
                  "id": 35714
                },
                {
                  "GName": "Grandjean",
                  "FName": "Lola",
                  "WNameOrd": "",
                  "id": 19459
                },
                {
                  "GName": "Paas",
                  "FName": "Meeri-Marita",
                  "WNameOrd": "",
                  "id": 17640
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "fXMnDxS",
              "path": "fXMnDxS",
              "athletes": [
                {
                  "GName": "Wieser",
                  "FName": "Felix",
                  "WNameOrd": "",
                  "id": 13105
                },
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "5NB6BPX",
              "path": "5NB6BPX",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                },
                {
                  "GName": "Barbelin",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 3283
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "fKJXJGL",
              "path": "fKJXJGL",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "2Wr9Lwk",
              "path": "2Wr9Lwk",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "h8xRZ4G",
              "path": "h8xRZ4G",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "g5QGvnZ",
              "path": "g5QGvnZ",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            }
          ]
        },
        "614": {
          "id": "614",
          "title": "FINALS",
          "images": [
            {
              "smugmug_id": "bxqbHXj",
              "path": "bxqbHXj",
              "athletes": [
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "qH4jtPV",
              "path": "qH4jtPV",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "7gZjVGv",
              "path": "7gZjVGv",
              "athletes": [
                {
                  "GName": "Wieser",
                  "FName": "Felix",
                  "WNameOrd": "",
                  "id": 13105
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "fGK7G8k",
              "path": "fGK7G8k",
              "athletes": [
                {
                  "GName": "Vetter",
                  "FName": "Jonathan",
                  "WNameOrd": "",
                  "id": 20657
                },
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "nkBTfKW",
              "path": "nkBTfKW",
              "athletes": [
                {
                  "GName": "Faber",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12511
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "HrBSP3q",
              "path": "HrBSP3q",
              "athletes": [
                {
                  "GName": "Rufer",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 13033
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "79H49WZ",
              "path": "79H49WZ",
              "athletes": [
                {
                  "GName": "Chirault",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 15723
                },
                {
                  "GName": "Chabin",
                  "FName": "Keziah",
                  "WNameOrd": "",
                  "id": 18922
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "nkSCQQ8",
              "path": "nkSCQQ8",
              "athletes": [
                {
                  "GName": "Chabin",
                  "FName": "Keziah",
                  "WNameOrd": "",
                  "id": 18922
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "S9mw4xM",
              "path": "S9mw4xM",
              "athletes": [
                {
                  "GName": "Bauer",
                  "FName": "Katharina",
                  "WNameOrd": "",
                  "id": 9036
                },
                {
                  "GName": "Barankova",
                  "FName": "Denisa",
                  "WNameOrd": "",
                  "id": 20532
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "nczn4HX",
              "path": "nczn4HX",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "65PPRvw",
              "path": "65PPRvw",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "bwXHXSW",
              "path": "bwXHXSW",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                },
                {
                  "GName": "Girard",
                  "FName": "Nicolas",
                  "WNameOrd": "",
                  "id": 19461
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "6wNGHCD",
              "path": "6wNGHCD",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "7x7fkZf",
              "path": "7x7fkZf",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "rHKpxqd",
              "path": "rHKpxqd",
              "athletes": [
                {
                  "GName": "Chirault",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 15723
                },
                {
                  "GName": "Wieser",
                  "FName": "Felix",
                  "WNameOrd": "",
                  "id": 13105
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "NCcP5fB",
              "path": "NCcP5fB",
              "athletes": [
                {
                  "GName": "Chirault",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 15723
                },
                {
                  "GName": "Wieser",
                  "FName": "Felix",
                  "WNameOrd": "",
                  "id": 13105
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "ncbXksf",
              "path": "ncbXksf",
              "athletes": [
                {
                  "GName": "Grandjean",
                  "FName": "Lola",
                  "WNameOrd": "",
                  "id": 19459
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "B7dfVr4",
              "path": "B7dfVr4",
              "athletes": [
                {
                  "GName": "Ackx",
                  "FName": "Enzo",
                  "WNameOrd": "",
                  "id": 8918
                },
                {
                  "GName": "Girard",
                  "FName": "Nicolas",
                  "WNameOrd": "",
                  "id": 19461
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "WghFMCv",
              "path": "WghFMCv",
              "athletes": [
                {
                  "GName": "Grandjean",
                  "FName": "Lola",
                  "WNameOrd": "",
                  "id": 19459
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "LrpHds4",
              "path": "LrpHds4",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "3BGM8sf",
              "path": "3BGM8sf",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Erika",
                  "WNameOrd": "",
                  "id": 3392
                },
                {
                  "GName": "De Giuli",
                  "FName": "Clementine",
                  "WNameOrd": "",
                  "id": 8879
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "5DGTdtK",
              "path": "5DGTdtK",
              "athletes": [
                {
                  "GName": "De Giuli",
                  "FName": "Clementine",
                  "WNameOrd": "",
                  "id": 8879
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "DrLz94x",
              "path": "DrLz94x",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "sKNxMSj",
              "path": "sKNxMSj",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "fZqkpRD",
              "path": "fZqkpRD",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "TS5X3Nc",
              "path": "TS5X3Nc",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                },
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "HVVfWsj",
              "path": "HVVfWsj",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "B6nH3kG",
              "path": "B6nH3kG",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "bThwXCg",
              "path": "bThwXCg",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "5tkBPBj",
              "path": "5tkBPBj",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                },
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "pG9x4MT",
              "path": "pG9x4MT",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "94fNMRH",
              "path": "94fNMRH",
              "athletes": [
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                },
                {
                  "GName": "Barbelin",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 3283
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "KnSszwv",
              "path": "KnSszwv",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "xt2gCbc",
              "path": "xt2gCbc",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "shzj8br",
              "path": "shzj8br",
              "athletes": [
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "qmL6tfG",
              "path": "qmL6tfG",
              "athletes": [
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "t2H58b3",
              "path": "t2H58b3",
              "athletes": [
                {
                  "GName": "Holgado",
                  "FName": "Juan Carlos",
                  "WNameOrd": "",
                  "id": 1059
                },
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "QFw94Qb",
              "path": "QFw94Qb",
              "athletes": [

              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "hVSMhRV",
              "path": "hVSMhRV",
              "athletes": [
                {
                  "GName": "Chirault",
                  "FName": "Thomas",
                  "WNameOrd": "",
                  "id": 15723
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "SM7kLqq",
              "path": "SM7kLqq",
              "athletes": [
                {
                  "GName": "De Giuli",
                  "FName": "Clementine",
                  "WNameOrd": "",
                  "id": 8879
                },
                {
                  "GName": "Damsbo",
                  "FName": "Erika",
                  "WNameOrd": "",
                  "id": 3392
                },
                {
                  "GName": "Paas",
                  "FName": "Meeri-Marita",
                  "WNameOrd": "",
                  "id": 17640
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "Tv3tFtn",
              "path": "Tv3tFtn",
              "athletes": [
                {
                  "GName": "Damsbo",
                  "FName": "Martin",
                  "WNameOrd": "",
                  "id": 2291
                },
                {
                  "GName": "Schloesser",
                  "FName": "Mike",
                  "WNameOrd": "",
                  "id": 6998
                },
                {
                  "GName": "Girard",
                  "FName": "Nicolas",
                  "WNameOrd": "",
                  "id": 19461
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "36zXpXs",
              "path": "36zXpXs",
              "athletes": [
                {
                  "GName": "Barbelin",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 3283
                },
                {
                  "GName": "Schloesser",
                  "FName": "Gabriela",
                  "WNameOrd": "",
                  "id": 8906
                },
                {
                  "GName": "Unruh",
                  "FName": "Lisa",
                  "WNameOrd": "",
                  "id": 5047
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            },
            {
              "smugmug_id": "cV3B8CC",
              "path": "cV3B8CC",
              "athletes": [
                {
                  "GName": "Unruh",
                  "FName": "Florian",
                  "WNameOrd": "",
                  "id": 12439
                },
                {
                  "GName": "Wijler",
                  "FName": "Steve",
                  "WNameOrd": "",
                  "id": 2631
                },
                {
                  "GName": "Wieser",
                  "FName": "Felix",
                  "WNameOrd": "",
                  "id": 13105
                }
              ],
              "competition": {
                "name": "Lausanne Invitational",
                "id": 23126,
                "place": "Lausanne",
                "country": "SUI",
                "date_start": "2020-12-20",
                "date_end": "2020-12-20"
              }
            }
          ]
        }
      }
    }
  ]
}




/**
 * The competitions gallery store.
 *
 * @export
 * @class CompetitionsGalleryStore
 * @extends {EntitiesStore<ITabPhotoContent>}
 */
export class CompetitionsGalleryStore extends EntitiesStore<ITabPhotoContent> {

  /**
   * The selected tag subject.
   *
   * @type {BehaviorSubject<string>}
   * @memberof CompetitionsGalleryStore
   */
  protected _defaultTag: BehaviorSubject<string> = new BehaviorSubject(undefined);

  /**
   * The tags list presented in the photos gallery.
   *
   * @type {BehaviorSubject<string>}
   * @memberof CompetitionsGalleryStore
   */
  tagsList : Array<string> = [];

  /**
   * Creates an instance of CompetitionsGalleryStore.
   * @param {Injector} injector The injector from Angular for get some services.
   * @param {HttpClient} http The http client from Angular.
   * @param {string} [competition_id] The competition id for make the request.
   * @memberof CompetitionsGalleryStore
   */
  constructor(protected injector:Injector,http: HttpClient, public competition_id?:string) {
    super('null', http);
  }

  get defaultTag(){
    return this._defaultTag.asObservable();
  }

  /**
   *
   * {@inheritdoc}
   * @returns {Observable<any>}
   * @memberof CompetitionsGalleryStore
   */
  getRequest(params: any, request_more: boolean = false): Observable<any> {
    this.loadingRef = true;

    return this.http.get(
      environment.drupal_api + (environment.competitions_gallery.replace('competition_id', this.competition_id)),
      {
        params:params
      })
      .pipe(
        tap((next: IGalleryPhotos) => {
          const data = this.prepareTabs(next);
          this.dataStream.next(data);
          this.data = data;
          this.loadingRef = false;
          this.requestMore = false;
        }));
  }

  /**
   *
   * Method for prepare the data in tabs.
   *
   * @returns {Observable<any>}
   * @memberof CompetitionsGalleryStore
   * @returns ITabPhotoContent[]
   */
  prepareTabs(data: IGalleryPhotos) {
    const resultArray: ITabPhotoContent[] = [];
    const mappedData = data && data.data[0] && data.data[0].tabs ? data.data[0].tabs : {};
    const mappedKeys = Object.keys(mappedData).map(key => key);
    mappedKeys.forEach(key => {
      resultArray.push(mappedData[key]);
    });
    if (resultArray.length > 0) {
      const param = this.injector.get(ActivatedRoute).snapshot.queryParams['photos_tag'];
      const findedParam = resultArray.find(value => value.title === param);
      this._defaultTag.next(findedParam  ? findedParam.title : resultArray[0].title);
      if(!findedParam){
        this.injector.get(Router).navigate([], {queryParams:{
          'photos_tag': resultArray[0].title
        }, queryParamsHandling:'merge'})
      }
      this.tagsList = resultArray.map(photo => photo.title);
    }
    return resultArray;
  }

  /**
   *
   * Method for get the photos filtered by a tag.
   *
   * @returns {Observable<any>}
   * @memberof CompetitionsGalleryStore
   * @returns ITabPhotoContent
   */
  get getPhotosFiltered() {
    return rx.combineLatest([
      this._defaultTag.asObservable().pipe(filter(a => a !== undefined)),
      this.dataStream.pipe(filter(a => a !== undefined))
    ]).pipe(map(([tag, photos]) => {
      const photosCasted = photos as ITabPhotoContent[];
      const tagCasted = tag as string;

      return photosCasted.find(tab => tab.title === tagCasted);
    }))
  }

  /**
   *
   * Method for set the selected tag.
   *
   * @returns {Observable<any>}
   * @memberof CompetitionsGalleryStore
   * @returns ITabPhotoContent
   */
  setTag(tag: string) {
    this._defaultTag.next(tag);
  }

}
